/** An alert's identity key: `alertType`, `alertType#propertyID`, or `alertType#propertyID#targetCellKey`. */
export type AlertKey = string;

export const ALERT_TOAST_ID_PREFIX = 'alert-';

export const getAlertToastId = (alertKey: AlertKey): string =>
  `${ALERT_TOAST_ID_PREFIX}${alertKey}`;

export const TOAST_DURATION_IN_MS = 7000;

export const TOAST_PERSISTENT_DURATION_IN_MS = Number.POSITIVE_INFINITY;

export const TOAST_CLASS_NAME = 'toolkit-react-hot-toast';

export const COMPARABLES_ALERTS_TOAST_CLASS_NAME = 'comparables-alerts-toast';

export const ALERT_TOAST_DATA_ATTR = 'data-alert-type';

export const ALERT_TOAST_PROPERTY_ID_ATTR = 'data-alert-property-id';

export const ALERT_TOAST_TARGET_CELL_KEY_ATTR = 'data-alert-target-cell-key';

export const ALERT_HOVER_PREVIEW_CELL_ATTR = 'data-alert-hover-preview-cell';

export const COMPARABLES_TOAST_TOP_CSS_VAR = '--comparables-toast-top';

export const COMPARABLES_TOAST_RIGHT_CSS_VAR = '--comparables-toast-right';
